import { APP_INITIALIZER, NgModule } from '@angular/core';
import { filter } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { AclService } from './acl.service';

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AclService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (aclService: AclService, authService: AuthService) => () => {
        authService.isAuthenticated$
          .pipe(
            filter(Boolean),
          )
          .subscribe(
            () => aclService.fetchAcl(),
          );
      },
      deps: [AclService, AuthService],
    }
  ],
})
export class AclModule {}
